module.exports = __webpack_public_path__ + "static/fatiregun-f18ef196b541528b6d507a0b92ad6c33.png";